import { LinkButton } from '@euler/app/components/LinkButton';
import { Typography } from '@euler/app/components/typography';
import { AddProductButton } from '@euler/app/flows/products/components/AddProductButton';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo, useCallback } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import { useTheme } from 'styled-components';

export const kMaintenanceAdviceFallbackText = '暂无';

export const MaintenanceAdviceCell = memo(
  ({
    text,
    style,
    onEditPress,
    onAssociateProductPress,
    ...props
  }: {
    text: string;
    style?: StyleProp<ViewStyle>;
    onEditPress?: () => void;
    canAssociateProduct: boolean;
    onAssociateProductPress?: (subject: string) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const {
      inspection: {
        siteInspection: {
          itemCard: {
            maintenanceAdviceLabelColor: labelColor,
            maintenanceAdviceTextColor: textColor,
            maintenanceAdviceBorderColor: borderColor,
            maintenanceAdviceBgColor: bgColor,
          },
        },
      },
    } = useTheme();

    const handleAssociateProduct = useCallback(() => {
      onAssociateProductPress?.(text);
    }, [onAssociateProductPress, text]);

    const canAssociateProduct =
      text !== kMaintenanceAdviceFallbackText && props.canAssociateProduct;

    return (
      <View style={style}>
        <View
          css={`
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            margin-bottom: ${rpx(10)}px;
          `}
        >
          <Typography.Label light size={rpx(14)} color={labelColor}>
            推荐项目:{' '}
          </Typography.Label>
          <LinkButton text="+编辑" onPress={onEditPress} />
        </View>
        <View
          css={`
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            flex-wrap: nowrap;
            background-color: ${bgColor};
            border-width: 1px;
            border-color: ${borderColor};
            min-height: ${rpx(39)}px;
            border-radius: ${rpx(5)}px;
            padding: ${rpx(4)}px ${rpx(15)}px;
          `}
        >
          <Typography.Label
            light
            size={rpx(15)}
            color={textColor}
            numberOfLines={0}
            css={`
              flex: 1;
            `}
          >
            {text}
          </Typography.Label>
          {canAssociateProduct && (
            <AddProductButton
              onPress={handleAssociateProduct}
              css={`
                margin-left: ${rpx(10)}px;
              `}
            />
          )}
        </View>
      </View>
    );
  },
);
